/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconCurrencyLeu = createReactComponent("currency-leu", "IconCurrencyLeu", [
  ["path", { d: "M17 18h-7a3 3 0 0 1 -3 -3v-10", key: "svg-0" }]
]);

export { IconCurrencyLeu as default };
//# sourceMappingURL=IconCurrencyLeu.js.map
